<template>
  <div class="room-type-popularity-report">
    <!-- Filters -->
    <b-card class="mb-4">
      <b-card-header>
        <h5 class="mb-0">
          <i class="fas fa-filter mr-2"></i>Filters
        </h5>
      </b-card-header>
      <b-card-body>
        <b-form @submit.prevent="fetchReport">
          <b-row>
            <b-col md="4">
              <b-form-group label="Date From:">
                <b-form-datepicker v-model="filters.date_from" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Date To:">
                <b-form-datepicker v-model="filters.date_to" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Hotel:">
                <b-form-select
                  v-model="filters.hotel_id"
                  :options="hotelOptions"
                  :disabled="loadingOptions"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="d-flex align-items-end">
              <b-button type="submit" variant="primary" :disabled="loading" class="mr-2">
                <i class="fas fa-search mr-2"></i>Apply Filters
              </b-button>
              <b-button variant="outline-secondary" @click="resetFilters" :disabled="loading">
                <i class="fas fa-times mr-2"></i>Clear
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <!-- Results -->
    <b-card>
      <b-card-header>
        <h5 class="mb-0">
          <i class="fas fa-chart-pie mr-2"></i>Room Type Popularity Results
        </h5>
      </b-card-header>
      <b-card-body class="p-0">
        <div v-if="loading" class="text-center p-4">
          <b-spinner variant="primary"></b-spinner>
          <p class="mt-2 mb-0">Loading room type popularity data...</p>
        </div>

        <b-table
          v-else
          :items="reportData"
          :fields="tableFields"
          :per-page="perPage"
          :current-page="currentPage"
          striped
          hover
          responsive
          show-empty
          empty-text="No room type data found"
        >
          <template #cell(average_price)="data">
            ${{ Number(data.item.average_price).toFixed(2) }}
          </template>

<!--          <template #cell(booking_frequency)="data">-->
<!--            <b-badge variant="info" class="mr-2">{{ data.item.booking_frequency }}</b-badge>-->
<!--            <div class="progress" style="height: 6px;">-->
<!--              <div-->
<!--                class="progress-bar bg-info"-->
<!--                :style="{ width: getPopularityPercentage(data.item.booking_frequency) + '%' }"-->
<!--              ></div>-->
<!--            </div>-->
<!--          </template>-->

          <template #cell(total_rooms_booked)="data">
            <strong class="text-primary">{{ data.item.total_rooms_booked }}</strong>
          </template>
        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="reportData.length"
            :per-page="perPage"
            class="mt-3"
          ></b-pagination>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { request } from '@/Util/Request';

export default {
  name: 'RoomTypePopularityReport',
  data() {
    return {
      loading: false,
      loadingOptions: false,
      filters: {
        date_from: '',
        date_to: '',
        hotel_id: null
      },
      reportData: [],
      tableFields: [
        { key: 'room_type_name', label: 'Room Type', sortable: true },
        { key: 'hotel_name', label: 'Hotel' },
        // { key: 'booking_frequency', label: 'Booking Frequency' },
        { key: 'total_rooms_booked', label: 'Total Rooms Booked', sortable: true },
        { key: 'average_price', label: 'Average Price', sortable: true }
      ],
      perPage: 10,
      currentPage: 1,
    };
  },
  props: {
    hotelOptions:{
      type: Array,
      required:true
    }
  },
  async mounted() {
    await this.fetchReport();
  },
  methods: {
    async fetchReport() {
      try {
        this.loading = true;
        const params = { ...this.filters };

        // Remove empty filters
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null) {
            delete params[key];
          }
        });

        const response = await request({
          method: 'get',
          url: '/hotel-reports/room-type-popularity',
          params
        });

        this.reportData = response;
      } catch (error) {
        console.error('Error fetching room type popularity report:', error);
        this.$bvToast.toast('Failed to load room type popularity report', {
          title: 'Error',
          variant: 'danger'
        });
      } finally {
        this.loading = false;
      }
    },

    resetFilters() {
      this.filters = {
        date_from: '',
        date_to: '',
        hotel_id: ''
      };
      this.fetchReport();
    },

    getPopularityPercentage(frequency) {
      if (this.reportData.length === 0) return 0;
      const maxFrequency = Math.max(...this.reportData.map(item => item.booking_frequency));
      return maxFrequency > 0 ? (frequency / maxFrequency) * 100 : 0;
    }
  },
};
</script>

<style scoped>
/* .room-type-popularity-report {
  padding: 20px;
} */

.progress {
  width: 100px;
  display: inline-block;
  margin-left: 10px;
}
</style>
